'use client';
import React, { ForwardedRef, forwardRef, ReactNode } from 'react';
import classNames from 'classnames';
import { NotificationType } from '@/src/app/components/Notification/types';
import Icon from '@/src/app/components/Icon/Icon';
import { IconName } from '@/src/app/components/Icon/types';

export type ToastProps = {
  message: string | ReactNode;
  type: NotificationType;
  onClose: () => void;
};

const Toast = forwardRef(({ message, onClose, type }: ToastProps, forwardedRef: ForwardedRef<HTMLDivElement>) => {
  const iconMap = {
    success: IconName.CHECK_CIRCLE,
    error: IconName.ERROR,
    info: IconName.INFO,
  };

  const styleMap = {
    success: 'bg-success',
    error: 'bg-danger',
    info: 'bg-information',
  };

  const textStyleMap = {
    success: 'text-white',
    error: 'text-white',
    info: 'text-black',
  };

  const toastIcon = iconMap[type] || null;
  const toastStyle = styleMap[type] || null;
  const toastTextStyle = textStyleMap[type] || null;

  return (
    <div
      className={classNames(
        'flex-1 w-full lg:max-w-xl mt-4 self-end px-4 py-3',
        'flex flex-row items-center',
        toastStyle,
        toastTextStyle,
      )}
      ref={forwardedRef}
      role="alert"
      data-testid={`toast-${type}`}
    >
      <div className={classNames('toast-message flex-1 flex flex-row items-center space-x-4')}>
        <Icon name={toastIcon} />
        <p>{message}</p>
      </div>
      <button className="toast-close-btn" onClick={onClose}>
        <Icon name={IconName.CLOSE} className="bloack!" />
      </button>
    </div>
  );
});

Toast.displayName = 'Toast';

export default Toast;
